/* Uses the inventory app's available quantities; never infers stock from collections. */
(() => {
  if (customElements.get('klifex-delivery')) return;
  const US_LOCATION = '108702368058';
  const UA_LOCATION = '107207033146';
  const inventory = new Map();
  let cart = null;
  let visitorCountry = null;
  const ingest = (rows) => {
    if (!Array.isArray(rows)) return;
    for (const row of rows) {
      if (Array.isArray(row.inventoryLocations)) inventory.set(String(row.variant), row);
    }
  };
  const refresh = () => document.querySelectorAll('klifex-delivery').forEach(card => card.update());
  const loadVisitorCountry = async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}browsing_context_suggestions.json?country[enabled]=true`, { headers: { Accept: 'application/json' } });
      if (response.ok) {
        const result = await response.json();
        const detected = result.detected_values?.country?.handle;
        if (typeof detected === 'string' && /^[A-Z]{2}$/i.test(detected)) visitorCountry = detected.toUpperCase();
      }
    } catch (_) {}
    refresh();
  };
  const loadCart = async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      if (response.ok) { cart = (await response.json()).items; refresh(); }
    } catch (_) { /* No domestic promise until cart quantities can be verified. */ }
  };
  document.addEventListener('inventoryInfo.appData', event => { ingest(event.detail?.variantLocations); refresh(); });
  document.addEventListener('inventoryInfo.appRendered', refresh);
  document.addEventListener('input', refresh);
  document.addEventListener('change', refresh);
  // The existing theme can add to cart asynchronously; recheck quantities afterwards.
  document.addEventListener('submit', event => {
    if (event.target.action?.includes('/cart/add')) setTimeout(loadCart, 1500);
  });
  window.addEventListener('focus', loadCart);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) loadCart(); });
  if (typeof subscribe === 'function') {
    ['cart:item-add', 'cart:item-remove', 'cart:item-quantity-update'].forEach(name => subscribe(name, () => { cart = null; refresh(); loadCart(); }));
    subscribe('product:variant-change', refresh);
    subscribe('product:quantity-update', refresh);
  }
  loadCart();

  class KlifexDelivery extends HTMLElement {
    connectedCallback() {
      this.started = Date.now();
      this.update();
      // Also catches quantity buttons and theme variant updates that do not emit change.
      this.timer = setInterval(() => this.update(), 350);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    update() {
      const data = this.dataset;
      const destination = visitorCountry;
      data.visitorCountry = destination || '';
      const usOnly = this.hasAttribute('data-us-only');
      const domesticOption = this.querySelector('[data-domestic-delivery]');
      ingest(window.inventoryInfo?.[data.handle]?.variantLocations);
      const form = document.getElementById(data.form);
      const variantId = String(form?.querySelector('[name="id"]')?.value || data.variant);
      const section = this.closest('.shopify-section');
      const quantityInput = section?.querySelector(`[name="quantity"][form="${data.form}"]`) || form?.querySelector('[name="quantity"]');
      const quantity = Math.max(1, Number(quantityInput?.value) || 1);
      const alreadyInCart = cart?.filter(item => String(item.variant_id) === variantId).reduce((sum, item) => sum + item.quantity, 0) || 0;
      const requested = quantity + alreadyInCart;
      const row = inventory.get(variantId);
      const locationQuantity = id => {
        const location = row?.inventoryLocations.find(item => String(item.location?.id) === id);
        // Complete variant records list connected warehouses; an unstocked warehouse has no entry.
        if (!location) return row ? 0 : null;
        return Number.isFinite(Number(location.quantity)) ? Math.max(0, Number(location.quantity)) : null;
      };
      const us = locationQuantity(US_LOCATION);
      const ua = locationQuantity(UA_LOCATION);
      let state = (!row || !cart) && Date.now() - this.started < 10000 ? 'checking' : 'unknown';
      if (row && cart && us !== null) {
        if (destination !== 'US' && ua !== null && ua >= requested) state = 'ua';
        else if (destination === 'US' && us >= requested) state = 'us';
        else if (ua !== null && ua >= requested && us === 0) state = 'ua';
        else if (destination === 'US' && us > 0 && ua !== null && us + ua >= requested) state = 'mixed';
        else if (ua !== null && (destination === 'US' ? us + ua : ua) < requested) state = 'short';
      }

      this.hidden = usOnly && state !== 'us';
      if (domesticOption) domesticOption.hidden = usOnly && state !== 'us';

      if (section) {
        section.dataset.klifexVisitorCountry = destination || '';
        section.classList.remove('klifex-stock-pending');
        section.classList.toggle('klifex-inventory-domestic', destination === 'US' && state === 'us');
      }
      const signature = `${state}:${us}:${variantId}`;
      if (this.signature === signature) return;
      this.signature = signature;
      const body = this.querySelector('[data-delivery-body]');
      const template = this.querySelector(`template[data-state="${state}"]`);
      if (!body || !template) return;
      body.replaceChildren(template.content.cloneNode(true));
      const stock = body.querySelector('[data-stock-count]');
      if (stock) stock.textContent = stock.textContent.replace('{count}', String(us));
      const panel = this.querySelector('[data-delivery-panel]');
      panel.hidden = state !== 'mixed' && state !== 'short';
      panel.className = `klifex-delivery klifex-delivery--${state}`;
      data.deliveryWarehouse = state;
    }
  }
  customElements.define('klifex-delivery', KlifexDelivery);
  loadVisitorCountry();
})();
